import {Injectable} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTab} from 'exc-tab-v2';
import {ExgAppControllerConfig} from '../misc/classes/ExgAppControllerConfig';
import {TabSettingsGlobalComponent} from '../settings/tab/tab-settings-global/tab-settings-global.component';
import {TabSettingsAutotextComponent} from '../settings/tab/tab-settings-autotext/tab-settings-autotext.component';
import {TabSettingsDefaultmessageComponent} from '../settings/tab/tab-settings-defaultmessage/tab-settings-defaultmessage.component';
import {TabSettingsDocumentlibraryComponent} from '../settings/tab/tab-settings-documentlibrary/tab-settings-documentlibrary.component';
import {TabSettingsQuestionsComponent} from '../settings/tab/tab-settings-questions/tab-settings-questions.component';
import {TabSettingsFormsComponent} from '../settings/tab/tab-settings-forms/tab-settings-forms.component';
import {
  TabSettingsScheduleTemplateComponent
} from '../settings/tab/tab-settings-schedule-template/tab-settings-schedule-template.component';

@Injectable({
  providedIn: 'root'
})
export class SettingsApplicationService extends ExcTranslation {
  GlobalSettings = {
    OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
      const tab = new ExgApplicationTab(
        'loading...',
        TabSettingsGlobalComponent,
        data,
        data,
        undefined,
        true
      );
      tab.Open();
      return tab;
    }
  };
  Case = {
    AutoTextSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        return this.AutoTextSettings.OpenTab(Object.assign(data, {mode: 'CASE'}), config);
      }
    },
    DefaultMessageSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        return this.DefaultMessageSettings.OpenTab(Object.assign(data, {mode: 'CASE'}), config);
      }
    },
    DefaultDocumentSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        return this.DefaultDocumentSettings.OpenTab(Object.assign(data, {mode: 'CASE'}), config);
      }
    }

  };
  Task = {
    AutoTextSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        return this.AutoTextSettings.OpenTab(Object.assign(data, {mode: 'TASK'}), config);
      }
    },
    DefaultMessageSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        return this.DefaultMessageSettings.OpenTab(Object.assign(data, {mode: 'TASK'}), config);
      }
    },
    DefaultDocumentSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        return this.DefaultDocumentSettings.OpenTab(Object.assign(data, {mode: 'TASK'}), config);
      }
    },
    ScheduleTemplateSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          TabSettingsScheduleTemplateComponent,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      }
    },
    FormsSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          TabSettingsFormsComponent,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      }
    },
    DialogQuestionSettings: {
      OpenTab: (data: any = {}, config?: ExgAppControllerConfig): ExgApplicationTab => {
        const tab = new ExgApplicationTab(
          'loading...',
          TabSettingsQuestionsComponent,
          data,
          data,
          undefined,
          true
        );
        tab.Open();
        return tab;
      }
    }
  };

  private AutoTextSettings = {
    OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
      const tab = new ExgApplicationTab(
        'loading...',
        TabSettingsAutotextComponent,
        data,
        data,
        {
          Unique: false
        },
        true
      );
      tab.Open();
      return tab;
    }
  };
  private DefaultMessageSettings = {
    OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
      const tab = new ExgApplicationTab(
        'loading...',
        TabSettingsDefaultmessageComponent,
        data,
        data,
        undefined,
        true
      );
      tab.Open();
      return tab;
    }
  };
  private DefaultDocumentSettings = {
    OpenTab: (data: any, config?: ExgAppControllerConfig): ExgApplicationTab => {
      const tab = new ExgApplicationTab(
        'loading...',
        TabSettingsDocumentlibraryComponent,
        data,
        data,
        undefined,
        true
      );
      tab.Open();
      return tab;
    }
  };

  constructor(
  ) {
    super();
  }
}
